export var SubscriptionOptionFrequency;
(function (SubscriptionOptionFrequency) {
    SubscriptionOptionFrequency["MONTH"] = "MONTH";
    SubscriptionOptionFrequency["DAY"] = "DAY";
    SubscriptionOptionFrequency["WEEK"] = "WEEK";
    SubscriptionOptionFrequency["YEAR"] = "YEAR";
    SubscriptionOptionFrequency["UNDEFINED"] = "UNDEFINED";
})(SubscriptionOptionFrequency || (SubscriptionOptionFrequency = {}));
//# sourceMappingURL=type.js.map